import { Button, Checkbox, Modal, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { create, useModal } from '@ebay/nice-modal-react';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import example from '../../../assets/example.jpg';
import styles from '../index.module.scss';
import { AUTO_LIGHT_TYPES, DocType } from '../const';
import { summaryStore } from '../store';

/**
 * 使用 nice-modal-react 封装的丰富内容弹窗（用于Step1阶段）
 */
const ContentEnrichmentModalForStep1 = create(
    observer(() => {
        const modal = useModal();

        const handleAutoLightChange = (types) => {
            summaryStore.onAutoLightChange(types);
        };

        const handleConfirm = () => {
            modal.resolve(summaryStore.autoLightTypes);
            modal.hide();
        };

        const handleCancel = () => {
            modal.reject(new Error('用户取消'));
            modal.hide();
        };

        // 根据文档类型过滤可用的选项
        const availableTypes = useMemo(() => {
            return AUTO_LIGHT_TYPES.filter(({ value }) => {
                // 毕业长文和课程长文显示全部
                if (
                    summaryStore.docType === DocType.GRADUATION_THESIS ||
                    summaryStore.docType === DocType.TERM_PAPER
                ) {
                    return true;
                }
                // 开题报告和文献综述只显示图和表
                if (
                    summaryStore.docType === DocType.PROPOSAL_REPORT ||
                    summaryStore.docType === DocType.LITERATURE_REVIEW
                ) {
                    return value === 'TABLE' || value === 'DIAGRAM';
                }
                return true;
            });
        }, [summaryStore.docType]);

        return (
            <Modal
                title="丰富全文内容"
                open={modal.visible}
                okText="继续生成大纲"
                footer={
                    <Button onClick={handleConfirm} type="primary">
                        确认
                    </Button>
                }
                maskClosable={false}
                closable={false}
                onCancel={handleCancel}
            >
                <div>
                    <div>
                        如您的全文需要包含
                        <hl>{availableTypes.map((item) => item.label).join('，')}</hl>
                        ，您可在在下方勾选相应选项，灵感会为您自动生成
                        <Tooltip
                            color="#fff"
                            title={
                                <span
                                    style={{
                                        color: '#18191c',
                                        width: '250px',
                                    }}
                                >
                                    您可根据全文需求需要勾选相应的
                                    <hl>{availableTypes.map((item) => item.label).join('，')}</hl>
                                    <br />
                                    在生成大纲后仍可继续进行<hl>添加或删减</hl>
                                    <br />
                                    点亮后，灵感会自动判断勾选内容需要的具体需求，如图所示：
                                    <img
                                        src={example}
                                        style={{
                                            color: '#18191c',
                                            width: '240px',
                                        }}
                                    />
                                </span>
                            }
                        >
                            <QuestionCircleOutlined
                                color="#999999"
                                className={styles.summaryIcon}
                                style={{ marginLeft: '4px' }}
                            />
                        </Tooltip>
                    </div>
                    <div
                        className={styles.summaryChecks}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <Checkbox.Group
                            value={summaryStore.autoLightTypes}
                            onChange={handleAutoLightChange}
                            disabled={summaryStore.isLoadingSummary}
                        >
                            {availableTypes.map(({ value, label }) => (
                                <Checkbox key={value} value={value}>
                                    {label}
                                </Checkbox>
                            ))}
                        </Checkbox.Group>
                    </div>
                    <a href="https://lingganfengbao.com/example" target="_blank" rel="noreferrer">
                        查看范文样例
                    </a>
                </div>
            </Modal>
        );
    }),
);

export default ContentEnrichmentModalForStep1;
